import { writable, derived } from "svelte/store";

export const menu = writable(null);
export const sushiboats = writable(0);
export const index = writable(0);

export const rolls = derived(menu, $menu => {
	let rolls = 0;

	$menu.sushiboats.list.map(item => {
		rolls += item.quantity;
	});

	return rolls;
});

export const steps = derived(menu, $menu => {

	if ($menu)
	{
		return ['availability', ...Object.keys($menu), 'info', 'checkout'];
	}

	return [];
});

export const summary = derived([menu, sushiboats], ([$menu, $sushiboats]) => {

	if ($menu)
	{
		let summary = {total: 0};

		Object.keys($menu).map(key => {

			let ob = {};
			let flag = false;

			$menu[key].list.map(item => {

				let total = 0;
				let quantities = [];

				item.sizes.map(size => {
					if (size.quantity)
					{
						summary.total += size.quantity * size.price;
						total += size.quantity * size.price;
						flag = true;
						quantities.push(size.quantity + " " + size.size);
					}

				})

				if (total > 0)
				{
					ob[item.title + " (" + quantities.join(" + ") + ")"] = total;
				}
			})

			if (flag)
			{
				summary[key] = ob;
			}

		});

		let title = [];

		if ($sushiboats > 0)
		{
			title = "sushiboats";

			summary[title] = $sushiboats * 17500;
			summary.total += $sushiboats * 17500;
		}

		summary.list = Object.keys(summary).filter(x => ['total', title].indexOf(x) == -1);

		return summary;
	}

	return null;
});


export const order = derived([menu, sushiboats], ([$menu, $sushiboats]) => {

	if ($menu)
	{
		let order = [];

		Object.keys($menu).map(key => {

			$menu[key].list.map(item => {

				item.sizes.map(size => {
					if (size.quantity)
					{
						let i = {};

						if (item.sizes.length > 1)
						{
							i.title = item.title + "(" + size.size + ")";
						}
						else
						{
							i.title = item.title;
						}

						i.quantity = size.quantity;
						i.price = size.price;

						order.push(i);
					}
				});
			})
		});

		if ($sushiboats > 0)
		{
			order.push({title: "Sushi Boats", price: 17500, quantity: $sushiboats});

			$menu.sushiboats.list.map(roll => {
				if (roll.quantity > 0)
				{
					order.push({title: roll.title, quantity: roll.quantity});
				}
			});
		}

		return order;
	}

	return null;
});


export const step = derived([steps, index], ([$steps, $index]) => {
	if ($steps && $steps[$index])
	{
		return $steps[$index];
	}

	return '';
});

export const nextstep = derived([steps, index], ([$steps, $index]) => {
	
	if ($steps && $steps[$index+1])
	{
		return $steps[$index+1];
	}

	return 'Next';
});

setTimeout(()=>{

	menu.set({
			appetizers: {
							title: "Select Appetizers",
							description: "Feeds upto 15-20 guests.",
							list: [
								{title: 'Edamame Small Trays', sizes: [{id: 1, size: 'qty', price: 1500, quantity: 0}]},
								{title: 'Spring Rolls (30 Rolls)', sizes: [{id: 2, size: 'qty', price: 2000, quantity: 0}]},
								{title: 'Shumai Shrimp Dumplings', sizes: [{id: 3, size: 'qty', price: 2000, quantity: 0}]},
								{title: 'Chicken Pot Sticks', sizes: [{id: 4, size: 'qty', price: 2500, quantity: 0}]},
								{title: 'Crispy Shrimp Tempura', sizes: [{id: 5, size: 'qty', price: 3500, quantity: 0}]},
								{title: 'Soft Shell Crab', sizes: [{id: 6, size: 'qty', price: 4000, quantity: 0}]},
							]
						},
			entrees: {
							title: "Select Entrees",
							description: "Small feeds upto 20 guests & Large feeds upto 40 guests.",
							list: [
								{title: 'Fried Rice', selectedSize: null, sizes: [{id: 7, size: 'Small', price: 4500, quantity: 0}, {id: 8, size: 'Large', price: 9000, quantity: 0}]},
								{title: 'Noodles', selectedSize: null, sizes: [{id: 9, size: 'Small', price: 4500, quantity: 0}, {id: 10, size: 'Large', price: 9000, quantity: 0}]},
								{title: 'Vegetables', selectedSize: null, sizes: [{id: 11, size: 'Small', price: 4000, quantity: 0}, {id: 12, size: 'Large', price: 8000, quantity: 0}]},
								{title: 'Garden Salad', selectedSize: null, sizes: [{id: 13, size: 'Small', price: 2500, quantity: 0}, {id: 14, size: 'Large', price: 5000, quantity: 0}]},
								{title: 'Soup (Miso and Broth)', selectedSize: null, sizes: [{id: 15, size: 'Small', price: 2500, quantity: 0}]},
							]
						},

			proteins: {
							title: "Select Proteins",
							description: "",
							list: [
								{title: 'Chicken', selectedSize: null, sizes: [{id: 16, size: 'Small', price: 6700, quantity: 0}, {id: 17, size: 'Large', price: 13500, quantity: 0}]},
								{title: 'Steak', selectedSize: null, sizes: [{id: 18, size: 'Small', price: 8700, quantity: 0}, {id: 19, size: 'Large', price: 17500, quantity: 0}]},
								{title: 'Shrimp', selectedSize: null, sizes: [{id: 20, size: 'Small', price: 8700, quantity: 0}, {id: 21, size: 'Large', price: 17500, quantity: 0}]},
								{title: 'Filet Mignon', selectedSize: null, sizes: [{id: 22, size: 'Small', price: 11000, quantity: 0}, {id: 23, size: 'Large', price: 22000, quantity: 0}]},
								{title: 'Lobster 6oz (10)', selectedSize: null, sizes: [{id: 24, size: 'Small', price: 2000, quantity: 0}]},
							]
						},
			sushiboats: {
							title: "Select Sushi Boats",
							description: "select Sushi Boats from our best collection.",
							list: [
								{title: 'Dragon', sizes: []},
								{title: 'Yellow Tail', sizes: []},
								{title: 'Red Snapper', sizes: []},
							]
						},
		});

}, 1000)